module.exports = __webpack_public_path__ + "img/IND-i-1-IV.9897ffb1.png";